import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { FieldviewLinkButton } from '../../components/fieldviewLinkButton/fieldview-link-button.component';
import { COMPANY_NAME, PRODUCT_NAME, PHONE, MAIL } from '../../utils/env';
import { TranslatePipe, TranslateImageURLPipe } from '../../pipes/translate.pipe';
import { SafePipe } from '../../pipes/safe.pipe';

@Component({
  standalone: true,
  selector: 'home-cmp',
  templateUrl: 'home.html',
  styleUrls: ['home.scss'],
  providers: [],
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, FieldviewLinkButton, TranslatePipe, SafePipe, TranslateImageURLPipe],
})
export class HomeComponent {
  companyName = COMPANY_NAME;
  productName = PRODUCT_NAME;
  phone = PHONE;
  mail = MAIL;
  constructor() {}
}
